// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".last-updated-container{align-items:center;color:var(--tertiary-text-color);display:flex;white-space:nowrap}.last-updated-container.is-compact{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
